"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getConditions,
  createCondition,
  updateCondition,
  deleteCondition,
} from "@/lib/api/conditions";
import type { UpdateConditionRequest } from "@/types/condition";
import { toast } from "sonner";

export function useConditions() {
  return useQuery({
    queryKey: ["conditions"],
    queryFn: getConditions,
  });
}

export function useCreateCondition() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCondition,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["conditions"] });
      toast.success("Condition added");
    },
    onError: (err: Error) => {
      toast.error(err.message);
    },
  });
}

export function useUpdateCondition() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateConditionRequest }) =>
      updateCondition(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["conditions"] });
      toast.success("Condition updated");
    },
    onError: (err: Error) => {
      toast.error(err.message);
    },
  });
}

export function useDeleteCondition() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCondition,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["conditions"] });
      toast.success("Condition removed");
    },
    onError: (err: Error) => {
      toast.error(err.message);
    },
  });
}
